<template>
    <ChecklistEditor />
  </template>
  
  <script>
  import ChecklistEditor from '../components/ChecklistEditor.vue';
  
  export default {
    components: { ChecklistEditor },
  };
  </script>